"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _recharts = require("recharts");

require("./SimpleLineChart.scss");

require("./SimpleLineChartDark.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // const CustomActiveDot = () => <div className='slc-custom-dot'><div className='slc-dot-center' /></div>


var CustomTooltip = function CustomTooltip(_ref) {
  var active = _ref.active,
      payload = _ref.payload,
      label = _ref.label,
      labelX = _ref.labelX,
      labelY = _ref.labelY,
      unit = _ref.unit;

  if (active && payload && payload.length) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "gcl-chart-tooltip"
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: "gcl-ct-x"
    }, labelX != null && /*#__PURE__*/_react["default"].createElement("span", null, labelX, ": "), /*#__PURE__*/_react["default"].createElement("span", null, label)), /*#__PURE__*/_react["default"].createElement("p", {
      className: "gcl-ct-y"
    }, labelY != null && /*#__PURE__*/_react["default"].createElement("span", null, labelY, ": "), /*#__PURE__*/_react["default"].createElement("span", null, "".concat(payload[0].value).concat(unit != null ? unit : ''))));
  }

  return null;
};

var SimpleLineChart = function SimpleLineChart(_ref2) {
  var data = _ref2.data,
      width = _ref2.width,
      height = _ref2.height,
      dataKeyY = _ref2.dataKeyY,
      dataKeyX = _ref2.dataKeyX,
      labelY = _ref2.labelY,
      labelX = _ref2.labelX,
      unit = _ref2.unit,
      tickCount = _ref2.tickCount,
      small = _ref2.small;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'gcl-simple-line-chart' + (small ? ' small' : '')
  }, /*#__PURE__*/_react["default"].createElement(_recharts.ResponsiveContainer, {
    width: width,
    height: height
  }, /*#__PURE__*/_react["default"].createElement(_recharts.LineChart, {
    data: data,
    margin: {
      top: 18,
      right: small ? 18 : 36,
      left: small ? 0 : 36,
      bottom: small ? 0 : 18
    }
  }, /*#__PURE__*/_react["default"].createElement(_recharts.CartesianGrid, {
    vertical: false
  }), /*#__PURE__*/_react["default"].createElement(_recharts.XAxis, {
    dataKey: dataKeyX,
    tickMargin: small ? 10 : 16,
    tickSize: small ? 4 : 9
  }), /*#__PURE__*/_react["default"].createElement(_recharts.YAxis, {
    dataKey: dataKeyY,
    tickMargin: 8,
    tickSize: small ? 12 : 18,
    unit: unit,
    type: "number",
    tickCount: tickCount
  }), /*#__PURE__*/_react["default"].createElement(_recharts.Tooltip, {
    offset: 5,
    content: /*#__PURE__*/_react["default"].createElement(CustomTooltip, {
      labelX: labelX,
      labelY: labelY,
      unit: unit
    })
  }), /*#__PURE__*/_react["default"].createElement(_recharts.Legend, null), /*#__PURE__*/_react["default"].createElement(_recharts.Line, {
    type: "linear",
    dataKey: dataKeyY,
    dot: false,
    strokeWidth: small ? 3 : 8,
    legendType: 'none',
    activeDot: small ? {
      strokeWidth: 4,
      r: 6
    } : {
      strokeWidth: 8,
      r: 16
    }
  }))));
};

var _default = SimpleLineChart;
exports["default"] = _default;